import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import "./responsive.css";
import AppRouter from "./app.route";
import { useCallback, useEffect, useState } from "react";
import { getErrorMessageSelector } from "./store/selectors/error.selector";
import { Button, Modal } from "antd";
import { VscError } from "react-icons/vsc";
import { setErrorMessage } from "./store/actions/error.action";
import { getLanguageSelector, serviceLoaderSelector } from "./store/selectors/app.selector";
import { useTranslation } from "react-i18next";
import BankLoader from "client/assets/LOGO/pageLoader.gif";
import { CONFIG } from "./environment";
import FAV_ICO from "client/assets/LOGO/favicon.png";
import { SET_SERVICE_LOADER } from "./store/constants";
import AuthService from "./services/auth.service";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { useNavigate } from "react-router";
import { store } from "./store";
import { setAppLanguage } from "./store/actions/app.action";
import i18n from "./i18n";

export default function App() {
  const dispatch = useDispatch();
  const errors = useSelector(getErrorMessageSelector);
  const [error, setError] = useState({});
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const serviceLoader = useSelector(serviceLoaderSelector);
  const { t } = useTranslation();
  const [pageReady, setPageReady] = useState(false);
  const navigate = useNavigate();
  const selectedLng = useSelector(getLanguageSelector);

  useEffect(() => {
    showErrors();
  }, [errors]);

  // useEffect(() => {//if minimize or went to next tab it will logout and will go to login page
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "hidden") {
  //       navigate("/login");
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);

  // useEffect(() => {
  //   // Check authentication status on reload
  //   const checkAuthentication = () => {
  //     const authToken = localStorage.getItem("authToken");
  //     if (!authToken) {
  //       navigate("/login");
  //     }
  //   };
  //   checkAuthentication();
  // }, []);

  useEffect(() => {
    // Disable backward navigation by pushing current state
    dispatch({ type: SET_SERVICE_LOADER, payload: false });
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      navigate("/login", { replace: true });
    };
    return () => {
      window.onpopstate = null;
    };
  }, []);

  useEffect(() => {
    document.title = `${CONFIG.BANK_NAME} | Internet Banking Portal`;

    // let link = document.querySelector("link[rel~='icon']");
    // if (!link) {
    //   link = document.createElement("link");
    //   link.rel = "icon";
    //   document.getElementsByTagName("head")[0].appendChild(link);
    // }
    // link.href = FAV_ICO;
  }, []);

   useEffect(() => {
    dispatch(setAppLanguage(selectedLng));
    i18n.changeLanguage(selectedLng);
  }, []);

  const showErrors = useCallback(() => {
    try {
      if (errors) {
        if ((errors.status === 400 || errors.status === 0) && !errors?.data) {
          setError({
            code: "Error",
            message: "The server is not reachable. Please try after some time.",
            errors: null,
          });
        } else if (errors.status === 403) {
          setError({
            code: "Error",
            message:
            errors.data.message ||
              "Your session has expired. Please log in again to continue.",
            errors: null,
          });
        } else {
          setError(errors?.data);
        }
        setIsErrorModalVisible(true);
      }
    } catch (err) {}
  }, [errors]);

  useEffect(() => {
    generateServerKey();
  }, []);

  const generateServerKey = useCallback(async () => {
    try {
      dispatch({ type: SET_SERVICE_LOADER, payload: false });
      const response = await AuthService.generateKey();
      if (response.status === 200) {
        setPageReady(true);
      }
    } catch (error) {
      setPageReady(true);
      dispatch({ type: SET_SERVICE_LOADER, payload: false });
    }
  }, []);

  return (
    <>
      {!pageReady && (
        <div id="splash-screen">
          <div class="logo">
            <img src={BANK_LOGO} alt="logo" />
          </div>

          <div id="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      )}

      {pageReady && <AppRouter />}

      <Modal
        open={isErrorModalVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <VscError
            style={{ display: "block", margin: "10px 0" }}
            size={50}
            fill="#ff4d4f"
          />
          <h5 className="mb-3" style={{ color: "#ff4d4f" }}>
            {" "}
            Alert!
          </h5>
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {error?.message ||
              "The server is not reachable. Please try after some time."}
          </p>
          <div align="center">
            <Button
              onClick={() => {
                setIsErrorModalVisible(false);
                dispatch(setErrorMessage(null));
              }}
              type="primary"
              size="large"
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={serviceLoader}
        footer={null}
        width={70}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal-loader"
      >
        <div align="center" className="loader-style">
          <img src={BankLoader} alt="loader" />
        </div>
      </Modal>
    </>
  );
}
